import { useEffect, useState } from 'react';

import { Dialog } from '@headlessui/react';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { DATE_FORMAT_TEMPLATE_YEAR } from 'api/constants';
import ActionButton from 'components/modals/common/buttons';

type pauseSubscription = {
  onConfirm: (value: Date | string) => void;
  onCancel: () => void;
  isLoading: boolean;
  title?: string;
  confirmCTACopy: string;
  dismissCTACopy: string;
  productName?: string;
  nextRenewCheck?: string | undefined;
};

export default function PauseSubscription({
  onConfirm,
  isLoading,
  onCancel,
  confirmCTACopy,
  dismissCTACopy,
  productName,
}: // nextRenewCheck,
pauseSubscription) {
  const initialDate = new Date();
  const formattedNextRenewCheck = dayjs(initialDate).format(
    DATE_FORMAT_TEMPLATE_YEAR
  );
  const [startDate, setStartDate] = useState(initialDate);

  useEffect(() => {
    const input = document.querySelector(
      '.react-datepicker__input-container>input'
    ) as HTMLInputElement;

    if (input) {
      input.focus = () => false;
    }
  }, []);
  const dismissHandler = () => {
    onCancel();
    setStartDate(initialDate);
  };
  const pauseSubscriptionHandler = () => {
    onConfirm(startDate);
  };

  const onChangeDatePickerHandler = (date: Date) => {
    setStartDate(date);
  };

  return (
    <>
      <div className={'bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4'}>
        <button onClick={onCancel} className="absolute top-4 right-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className={'sm:flex sm:items-start'}>
          <div className={'mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left'}>
            <Dialog.Title
              as="h3"
              className={'text-base leading-6 text-gray-900'}
            >
              {productName && (
                <span className={'font-semibold'}>{productName}</span>
              )}{' '}
              <div
                style={{
                  fontSize: '13px',
                  color: 'grey',
                  letterSpacing: '0.5px',
                }}
              >
                Next expected renewal date is:
              </div>
            </Dialog.Title>
            <div
              className={'font-semibold pt-4'}
              style={{ letterSpacing: '0.5px' }}
            >
              {formattedNextRenewCheck}
            </div>
            <div>
              <div className={'pb-4'}>
                <div
                  style={{
                    margin: '14px 0',
                    fontSize: '13px',
                    color: 'grey',
                    letterSpacing: '0.5px',
                  }}
                >
                  Select the date until you want to pause the subscription
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <DatePicker
                    minDate={startDate}
                    autoFocus={false}
                    dateFormat="yyyy-MM-dd"
                    selected={startDate}
                    // @ts-expect-error inconsistency in the types
                    onChange={onChangeDatePickerHandler}
                  />
                </div>

                <div
                  style={{
                    margin: '14px 0',
                    fontSize: '13px',
                    color: 'grey',
                    letterSpacing: '0.5px',
                  }}
                >
                  <p>
                    Customer will lose access to feature immediately and will
                    get back access after the pausing date.
                  </p>
                  <p>Subscription can be paused for a max 6 months period.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={' px-4 sm:flex sm:px-6'}
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          paddingBottom: '50px',
          paddingTop: '3.75rem',
        }}
      >
        <ActionButton
          dataTestId="e2e-move-renewal-date-btn"
          onClick={pauseSubscriptionHandler}
          label={dismissCTACopy}
          additionalStyles={{
            width: '50%',
            opacity: startDate === initialDate ? '0.5' : '1',
          }}
          disabled={startDate === initialDate}
        />
        <ActionButton
          dataTestId="e2e-dismiss-btn"
          onClick={dismissHandler}
          disabled={isLoading}
          label={confirmCTACopy}
          additionalStyles={{ marginTop: '8px', width: '50%' }}
        />
      </div>
    </>
  );
}
